import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["current", "count", "onChange"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Pagination/Pagination.js",
    _this = this;

import React from 'react';
import { ArrowLeft as ArrowLeftIcon, ArrowRight as ArrowRightIcon } from '@dls/assets/icons';
import { StyledPaginationRoot, StyledPaginationUl, StyledPaginationButton, StyledPaginationItemEllipsis } from './styles';
import usePagination from './hooks/usePagination';

var Pagination = function Pagination(_ref) {
  var current = _ref.current,
      count = _ref.count,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _usePagination = usePagination({
    current: current,
    count: count,
    onChange: onChange
  }),
      paginationArr = _usePagination.paginationArr,
      onPageChange = _usePagination.onPageChange;

  var getIcons = function getIcons(content) {
    switch (content) {
      case 'prev':
        return /*#__PURE__*/React.createElement(ArrowLeftIcon, {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 26,
            columnNumber: 16
          }
        });

      case 'next':
        return /*#__PURE__*/React.createElement(ArrowRightIcon, {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29,
            columnNumber: 16
          }
        });

      default:
        return content;
    }
  };

  return /*#__PURE__*/React.createElement(StyledPaginationRoot, {
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(StyledPaginationUl, {
    "data-testid": "pagination-list",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }, paginationArr.map(function (item, index) {
    if (item.linkToPage) {
      return /*#__PURE__*/React.createElement("li", {
        key: index,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(StyledPaginationButton, {
        "data-testid": item.active ? 'selected' : "page-".concat(item.content),
        disabled: item.disabled,
        selected: item.active,
        onClick: function onClick() {
          return onPageChange(item.linkToPage);
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 17
        }
      }, getIcons(item.content)));
    }

    return /*#__PURE__*/React.createElement(StyledPaginationItemEllipsis, {
      key: index,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 13
      }
    }, item.content);
  })));
};

Pagination.defaultProps = {
  current: 1,
  count: 10,
  onChange: function onChange() {},
  'data-testid': 'pagination'
};
export default Pagination;